module.exports = __webpack_public_path__ + "media/images/sp/brands/tvb/store_kobe-0fceea562de621683b35a0d6b79cf033.jpg";